import { toAccessor } from '@studio/react-utils';
import type { ReactElement } from 'react';
import { useRightTabPref } from './hooks.js';
import { Root } from './root.jsx';
import { Triggers } from './triggers.jsx';
import type { PlaceholderProps } from './types.js';

/** `<Placeholder>` component. */
export const Placeholder = (props: PlaceholderProps): ReactElement => {
  const tab = toAccessor(useRightTabPref());

  return (
    <Root {...props} tab={tab}>
      <Triggers disabled />
    </Root>
  );
};
